import { Modal } from '@/components/ui/Modal';
import { Button } from '@/components/ui/Button';

type TypeConfirmDialogProps = {
  isOpen: boolean;
  title: string;
  description: string;
  confirmWord?: string;
  confirmLabel: string;
  pending?: boolean;
  pendingLabel?: string;
  confirmValue: string;
  onConfirmValueChange: (value: string) => void;
  onCancel: () => void;
  onConfirm: () => void;
};

export function TypeConfirmDialog({
  isOpen,
  title,
  description,
  confirmWord = 'DELETE',
  confirmLabel,
  pending,
  pendingLabel,
  confirmValue,
  onConfirmValueChange,
  onCancel,
  onConfirm,
}: TypeConfirmDialogProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      title={title}
      footer={
        <>
          <Button variant="secondary" onClick={onCancel} disabled={pending}>
            Cancel
          </Button>
          <Button
            variant="primary"
            className="bg-rose-600 hover:bg-rose-700 focus-visible:ring-rose-600"
            disabled={pending || confirmValue !== confirmWord}
            onClick={onConfirm}
          >
            {pending ? pendingLabel ?? 'Working…' : confirmLabel}
          </Button>
        </>
      }
    >
      <p className="text-sm text-slate-600">{description}</p>
      <label className="mb-1 mt-4 block text-sm font-medium text-slate-700">
        Type {confirmWord} to confirm
      </label>
      <input
        type="text"
        className="w-full rounded-lg border border-slate-300 px-3 py-2 text-base sm:text-sm min-h-[40px] shadow-sm focus:border-brand focus:outline-none focus:ring-2 focus:ring-brand/30"
        value={confirmValue}
        onChange={(event) => onConfirmValueChange(event.target.value)}
        autoFocus
      />
    </Modal>
  );
}
